import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSideBarfilesActions,
  setPerformanceDeleteAction,
} from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import "../../../StyleSheet/MainComponent/Performance/Performance.scss";
import PerformanceTable from "./PerformanceTable";
import PerformancePopup from "./PerformancePopup";
import Delete from "../../AppComponent/Popup/Delete";

function Performance() {
  const dispatch = useDispatch();
  const [createEditPopup, setCreateEditPopup] = useState(false);
  const [editPayload, setEditPayload] = useState({});
  const [deleteID, setDeleteID] = useState("");
  const [DeletePopup, setDeletepopup] = useState(false);

  const [pageNum, setPageNu] = useState();
  const dtpageindex = (dtpageindex) => {
    setPageNu(dtpageindex);
  };
  const [typeOfParent, setEmplyHeaders] = useState([
    {
      value: "Tech",
      label: "Technical",
    },
    {
      value: "soft",
      label: "Soft Services",
    },
  ]);

   const [Searchcriteris , setSearch] = useState()
  const [EMpHeaderSelected, setEmpHeadersSele] = useState(typeOfParent[0]);
 const searchchanges =(e)=>{
  //  console.log(e , "37282730382");
  setSearch(e)
 }
  const [typeOfperformance, setPerformances] = useState("Tech");

  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const performanceData = useSelector(
    (state) => state.performanceTypeCall.performanceDatas
  );
  useEffect(() => {
    {
      Object.keys(editPayload).length > 0 && setCreateEditPopup(true);
    }
  }, [editPayload]);
  // useEffect(() => {
  //   if (deleteID.length > 0) {
  //     dispatch(setPerformanceDeleteAction(deleteID));
  //   }
  // }, [deleteID]);
  const HandleSubmits = () => {
    if (deleteID != undefined) {
      const payload = {
        DeleteID: deleteID,
        page: pageNum,
        parent_type: typeOfperformance,
         search:Searchcriteris
      };
      dispatch(setPerformanceDeleteAction(payload, setDeletepopup(false)));
    }
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Criteria</h3>
            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <NavLink
                  style={{ textDecoration: "none", color: "#333333" }}
                  to={"/performance"}
                  onClick={(e) => {
                    dispatch(getSideBarfilesActions("Criteria"));
                  }}
                >
                  Criteria
                </NavLink>
              </li>
            </ul> */}
          </div>
          <div className="Add-User col-sm-5">
            <button
              onClick={() => {
                setCreateEditPopup(true);
              }}
              className="ButtonCSS"
            >
              Create
            </button>
          </div>
        </div>
        <br/>
        <PerformanceTable
          performanceData={performanceData}
          setCreateEditPopup={setCreateEditPopup}
          setEditPayload={setEditPayload}
          setDeleteID={setDeleteID}
          EMpHeaderSelected={EMpHeaderSelected}
          typeOfParent={typeOfParent}
          typeOfperformance={typeOfperformance}
          setEmpHeadersSele={setEmpHeadersSele}
          setPerformances={setPerformances}
          setDeletepopup={setDeletepopup}
          setEmplyHeaders={setEmplyHeaders}
          dtpageindex={dtpageindex}
          searchchanges={searchchanges}
        />
      </div>

      <PerformancePopup
        show={createEditPopup}
        setShow={setCreateEditPopup}
        editPayload={editPayload}
        setEditPayload={setEditPayload}
        EMpHeader={EMpHeaderSelected}
         search={Searchcriteris}
      />

      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletepopup}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete the Criteria"}

        />
      ) : null}
    </>
  );
}

export default Performance;
